//引入i18n
import { createI18n } from 'vue-i18n'
import enLocale from './en/index'
import cnLocale from './cn/index'
import twLocale from './tw/index'

//创建i18n对象
const i18n = createI18n({
 locale: localStorage.getItem('lang') || "cn",
 fallbackLocale: localStorage.getItem('lang') || "cn",
 globalInjection: true,
 legacy: false,
 messages: {
  tw: twLocale,
  cn: cnLocale,
  en: enLocale,
 }
})

export default i18n